module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"sign_modal.title":"กรุณาลงลายมือชื่อ","sign_modal.name.and.surname":"ชื่อ-สกุล","sign_modal.name.and.surname.placeholder":"กรุณากรอกชื่อและนามสกุลเต็ม","sign_modal.resign":"ลบลายมือชื่อ","sign_modal.warning":"กรุณาลงลายมือชื่อและกรอกชื่อ-สกุลให้ครบถ้วน"}}')
  delete Component.options._Ctor
}
